import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=72599fec&scoped=true"
import script from "./empty.vue?vue&type=script&lang=ts"
export * from "./empty.vue?vue&type=script&lang=ts"
import style0 from "./empty.vue?vue&type=style&index=0&id=72599fec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72599fec",
  null
  
)

export default component.exports